import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Constant } from '../constants/constant';
import { UserService } from './user.service';

export interface PrescriptionDocument {
  documentId: number;
  fileName: string;
  filePath: string;
  fileType?: string;
  fileSize?: number;
}

export interface Prescription {
  prescriptionId: number;
  prescriptionName?: string;
  doctorName?: string;
  hospitalName?: string;
  prescriptionDate?: string;
  validUntil?: string;
  status: string;
  medicineCount: number;
  documents: PrescriptionDocument[];
  source: string;
  sourceOrderId?: number;
}

export interface PrescriptionOrderRequest {
  requestId?: number;
  prescriptionId: number;
  pharmacyId?: string;
  secondaryTenantId?: string;
  status?: string;
  quoteId?: number;
  orderId?: number;
  customerNote?: string;
  sourceType?: string;
}

export interface ReorderRequestPayload {
  secondaryTenantId?: string;
  prescriptionId?: number;
  selectedOrderItemIds?: number[];
  action?: string;
}

export interface ReorderResponse {
  success: boolean;
  quoteId?: number;
  prescriptionRequestId?: number;
  prescriptionRequired: boolean;
  prescriptionValid: boolean;
  itemsAdded: number;
  itemsUnavailable: string[];
  priceChangedItems: {
    productId: number;
    productName: string;
    previousPrice: number;
    currentPrice: number;
  }[];
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class PrescriptionService {

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) { }

  urlCore = environment.serverAPI2 + "/api/core";
  urlCoreIg = environment.serverAPI2 + "/api/ig/core";
  urlPartner = (environment.serverAPI6 || environment.serverAPI2) + "/api/partner";

  normalUploadFiles(data: FormData, type: any): Observable<Object> {
    let authorized = this.userService.getAuthenticatedUser();
    let guestLoginEnabled = localStorage.getItem(Constant['GUEST_LOGIN']);
    if (guestLoginEnabled == "0" || authorized) {
      return this.http.post(`${this.urlCore}/normal/uploadMultipleFiles?type=${type}`, data);
    } else {
      return this.http.post(`${this.urlCoreIg}/normal/uploadMultipleFiles?type=${type}`, data);
    }
  }

  uploadPrescription(formData: FormData): Observable<any> {
    return this.http.post(`${this.urlPartner}/prescriptions`, formData);
  }

  getPrescriptionVault(page: number = 0, size: number = 20): Observable<any> {
    return this.http.get(`${this.urlPartner}/prescriptions?page=${page}&size=${size}`);
  }

  getPrescription(prescriptionId: number): Observable<Prescription> {
    return this.http.get<Prescription>(`${this.urlPartner}/prescriptions/${prescriptionId}`);
  }

  createPrescriptionRequest(prescriptionId: number, body: PrescriptionOrderRequest): Observable<PrescriptionOrderRequest> {
    return this.http.post<PrescriptionOrderRequest>(`${this.urlPartner}/prescriptions/${prescriptionId}/requests`, body);
  }

  getPreviousPrescriptionOrders(page: number = 0, size: number = 10): Observable<any> {
    return this.http.get(`${this.urlPartner}/prescriptions/orders?page=${page}&size=${size}`);
  }

  reorder(orderId: number, payload: ReorderRequestPayload): Observable<ReorderResponse> {
    return this.http.post<ReorderResponse>(`${this.urlPartner}/order/${orderId}/reorder`, payload);
  }

  getPrescriptionRequest(requestId: number): Observable<PrescriptionOrderRequest> {
    return this.http.get<PrescriptionOrderRequest>(`${this.urlPartner}/prescription-requests/${requestId}`);
  }
}
